import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { useContextSelector } from 'use-context-selector'
import { ScheduleFilterSelectContext } from './ScheduleFilterSelectContext'
import {
  FilterAccordion,
  FilterAccordionDetails,
  FilterAccordionSummary,
  FilterAccordionTitle,
  FilterAccordionTitleContainer,
  FilterWrapper,
} from './ScheduleFilterSelect.styles'
import { Radio } from '@mui/material'
import { SCHEDULE_FILTER } from '@pages/private/Schedule/components/EventFilters/types'
import { ScheduleFilterSelectOptions } from './ScheduleFilterSelectOptions'

export function ScheduleFilterSelectView(): JSX.Element {
  const [activeFilter, setActiveFilter] = useContextSelector(
    ScheduleFilterSelectContext,
    (s) => [s.activeFilter, s.setActiveFilter]
  )

  const filter = useContextSelector(
    ScheduleFilterSelectContext,
    (s) => s.filter
  )

  const options = useContextSelector(
    ScheduleFilterSelectContext,
    (s) => s.options
  )

  const selectOption = useContextSelector(
    ScheduleFilterSelectContext,
    (s) => s.handleChangeSelectOption
  )

  const active = activeFilter === filter.key

  const createComponents = () => {
    const comps = new Array<JSX.Element>()
    if (!active) return comps
    if (filter.subFilter)
      filter.subFilter.forEach((subfilter) => {
        comps.push(
          <ScheduleFilterSelectOptions
            key={subfilter.attr + subfilter.label}
            filter={subfilter}
            active={active}
          />
        )
      })
    else
      comps.push(
        <ScheduleFilterSelectOptions
          options={options}
          filter={filter}
          active={active}
          key={filter.attr + filter.label}
        />
      )
    return comps
  }

  return (
    <FilterWrapper
      style={{
        display:
          activeFilter === SCHEDULE_FILTER.UNDEFINED || active
            ? 'initial'
            : 'none',
      }}
    >
      <FilterAccordion
        expanded={active}
        data-cy={`Schedule-filter-select-component-${filter.label}`}
        onChange={(_, expanded) => {
          if (expanded) {
            setActiveFilter(filter.key ? filter.key : SCHEDULE_FILTER.UNDEFINED)
          } else {
            const params = new Array<unknown>()
            if (filter.subFilter)
              filter.subFilter?.forEach((f) => {
                params.push({
                  filter: f.attr,
                  key: '',
                })
              })
            else
              params.push({
                filter: filter.attr,
                key: '',
              })
            selectOption(params as never)
            setActiveFilter(SCHEDULE_FILTER.UNDEFINED)
          }
        }}
      >
        <FilterAccordionSummary
          expandIcon={active ? null : <ChevronRightIcon fontSize="small" />}
        >
          <Radio
            checkedIcon={
              <ChevronLeftIcon
                sx={{
                  color: '#202122',
                }}
                fontSize="small"
              />
            }
            size="small"
            checked={active}
            sx={{
              color: active ? '#202122' : '#B6BCC9',
              '&.MuiButtonBase-root': {
                padding: 0,
                marginRight: '4px',
              },
            }}
          />
          <FilterAccordionTitleContainer>
            <FilterAccordionTitle
              sx={{
                fontWeight: active ? 600 : 400,
              }}
            >
              {filter.label}
            </FilterAccordionTitle>
          </FilterAccordionTitleContainer>
        </FilterAccordionSummary>
        <FilterAccordionDetails>{createComponents()}</FilterAccordionDetails>
      </FilterAccordion>
    </FilterWrapper>
  )
}
